import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import SettingsBrightnessRoundedIcon from '@mui/icons-material/SettingsBrightnessRounded';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useColorScheme } from '@mui/material/styles';

type Mode = 'light' | 'dark' | 'system';
type Option = { value: Mode; label: string; Icon: typeof LightModeRoundedIcon };

// A ordem em que cada clique avança: claro → escuro → sistema → claro…
const cycle = [
  { value: 'light', label: 'Claro', Icon: LightModeRoundedIcon },
  { value: 'dark', label: 'Escuro', Icon: DarkModeRoundedIcon },
  { value: 'system', label: 'Sistema', Icon: SettingsBrightnessRoundedIcon },
] as const satisfies readonly Option[];

/**
 * Um botão só: cada clique passa para a próxima opção (claro, escuro, sistema) e o ícone
 * mostra a que está em vigor. O MUI guarda a escolha no `localStorage` e o script do
 * `index.html` a reaplica antes do primeiro paint.
 */
export function ThemeModeToggle() {
  const { mode, setMode } = useColorScheme();

  const current = cycle.find((option) => option.value === (mode ?? 'system')) ?? cycle[2];
  const next = cycle[(cycle.indexOf(current) + 1) % cycle.length] ?? cycle[0];

  return (
    <Tooltip title={`Tema: ${current.label} · próximo: ${next.label}`}>
      <IconButton
        aria-label={`Tema: ${current.label}`}
        onClick={() => setMode(next.value)}
        color="inherit"
      >
        <current.Icon />
      </IconButton>
    </Tooltip>
  );
}
